// Vendor
import * as I18next from 'i18next';
import * as LanguageDetector from 'i18next-browser-languagedetector';
import * as Backend from 'i18next-xhr-backend';

// Config
import {NODE_ENV} from 'isee/config/environment';

const loadLocales = async (
  url: string,
  _options: {},
  callback: (locale: any, status: {}) => {}
) => {
  try {
    const locale = await import(`isee/locales/${url}.json`);
    callback(locale, {status: '200'});
  } catch (e) {
    callback(null, {status: '404'});
  }
};

const detectorConfig = {
  order: ['cookie', 'localStorage', 'navigator'],

  // querystring
  lookupQuerystring: 'lng',

  // cookie
  cookieDomain: 'isee',
  cookieMinutes: 10,
  lookupCookie: 'i18next',

  // localStorage
  lookupLocalStorage: 'i18nextLng',

  // caching
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode']
};

const i18NextConfig = {
  backend: {
    ajax: loadLocales,
    loadPath: '{{ns}}/{{lng}}',
    parse: (data: any) => data
  },
  debug: NODE_ENV === 'development',
  defaultNS: 'isee',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  },
  load: 'languageOnly' as 'languageOnly',
  ns: ['isee'],
  react: {
    wait: true
  },

  // Detector config
  detection: detectorConfig
};

export class I18nService {
  private _i18n: I18next.i18n;
  public get i18n() {
    return this._i18n;
  }

  constructor() {
    this._i18n = I18next.use(Backend)
      .use(LanguageDetector)
      .init(i18NextConfig);
  }
}

export default new I18nService();



// WEBPACK FOOTER //
// ./src/services/i18next/i18next.ts